import QRImgLegales from '../../assets/img/QR_legales.svg';
import QRImgRegistro from '../../assets/img/QR_registro.svg';
import Twitter from '../../assets/icons/twitter.svg';
import Instagram from '../../assets/icons/instagram.svg';
import Facebook from '../../assets/icons/facebook.svg';
import Youtube from '../../assets/icons/youtube.svg';
import AppStore from '../../assets/icons/app_store.svg';
import GooglePlay from '../../assets/icons/google_play.svg';
import ZonaLandingImgLOGO from '../../assets/img/logoZPAR.svg';

const ZPARDataFooter = {
  footerLinks: [
    {
      title: 'Más Zonaprop',
      content: [
        {
          controlPanel: 'inmuebles-argentina',
          wording: 'Inmuebles en Argentina',
          link: 'https://www.zonaprop.com.ar/inmuebles.html'
        },
        {
          controlPanel: 'publica',
          wording: 'Publicar tu Inmueble',
          link: 'https://www.zonaprop.com.ar/publica-tu-propiedad'
        },
        {
          controlPanel: 'ayuda',
          wording: 'Ayuda',
          link: 'https://help.zonaprop.com.ar/es'
        },
        {
          controlPanel: 'mapa-sitio',
          wording: 'Mapa del sitio',
          link: 'https://www.zonaprop.com.ar/sitemaps/'
        },
        {
          controlPanel: 'publicidad',
          wording: 'Publicidad',
          link: 'http://www.naventmedia.com/'
        },
        {
          controlPanel: 'noticias',
          wording: 'Noticias',
          link: 'https://www.zonaprop.com.ar/noticias/'
        },
        {
          controlPanel: 'valuador',
          wording: 'Valuador',
          link: 'https://www.zonaprop.com.ar/valuador'
        },
        {
          controlPanel: 'garantias-alquiler',
          wording: 'Garantías de Alquiler',
          link: 'https://garantias.zonaprop.com.ar/'
        }
      ]
    },
    {
      title: 'Anunciantes',
      content: [
        {
          controlPanel: 'inmobiliarias',
          wording: 'Inmobiliarias',
          link: 'https://www.zonaprop.com.ar/inmobiliarias.bum'
        },
        {
          controlPanel: 'corredores',
          wording: 'Corredores',
          link: 'https://www.zonaprop.com.ar/corredores.bum'
        },
        {
          controlPanel: 'constructoras',
          wording: 'Constructoras',
          link: 'https://www.zonaprop.com.ar/constructoras.bum'
        }
      ]
    },
    {
      title: 'Países',
      content: [
        {
          controlPanel: 'brasil',
          wording: 'Brasil',
          options: [
            {
              wording: 'Imovelweb',
              link: 'https://www.imovelweb.com.br'
            },
            {
              wording: 'Wimoveis',
              link: 'https://www.wimoveis.com.br'
            },
            {
              wording: 'CasaMineira',
              link: 'https://www.casamineira.com.br'
            },
            {
              wording: 'QuintoAndar',
              link: 'https://www.quintoandar.com.br/ '
            }
          ]
        },
        {
          controlPanel: 'mexico',
          wording: 'México',
          options: [
            {
              wording: 'Inmuebles24',
              link: 'https://www.inmuebles24.com'
            },
            {
              wording: 'Vivanuncios',
              link: 'https://www.vivanuncios.com.mx'
            }
          ]
        },
        {
          controlPanel: 'peru',
          wording: 'Perú',
          options: [
            {
              wording: 'Urbania',
              link: 'https://www.urbania.pe'
            },
            {
              wording: 'Adondevivir',
              link: 'https://www.adondevivir.com'
            }
          ]
        },
        {
          controlPanel: 'ecuador',
          wording: 'Ecuador',
          options: [
            {
              wording: 'Plusvalia',
              link: 'https://www.plusvalia.com'
            }
          ]
        },
        {
          controlPanel: 'panama',
          wording: 'Panamá',
          options: [
            {
              wording: 'Compreoalquile',
              link: 'https://www.compreoalquile.com'
            }
          ]
        }
      ]
    }
  ],
  socialMedia: {
    title: 'Seguinos en',
    content: [
      {
        wording: 'Facebook',
        link: 'https://www.facebook.com/zonaprop',
        src: Facebook
      },
      {
        wording: 'Instagram',
        link: 'https://instagram.com/zonaprop',
        src: Instagram
      },
      {
        wording: 'Youtube',
        link: 'https://youtube.com/channel/UCZKqtgqbg6I-oWz_nBA_qCA',
        src: Youtube
      },
      {
        wording: 'Twitter',
        link: 'https://twitter.com/zonaprop',
        src: Twitter
      }
    ]
  },
  fiscalQR: [
    {
      src: QRImgRegistro,
      url: 'https://www.argentina.gob.ar/aaip/datospersonales/reclama/30710244010--RL-2019-92450982-APN-DNPDP#AAIP'
    },
    {
      src: QRImgLegales,
      url: 'https://servicioscf.afip.gob.ar/publico/denuncias/denunciaCD.aspx'
    }
  ],
  appsLinks: {
    title: 'Apps',
    content: [
      {
        wording: 'AppStore',
        link: 'https://apps.apple.com/pe/app/zonaprop/id531131585',
        src: AppStore
      },
      {
        wording: 'GooglePlay',
        link: 'https://play.google.com/store/apps/details?id=com.zonaprop.android',
        src: GooglePlay
      }
    ]
  },
  legalLinks: {
    termsAndConditions: {
      url: 'https://help.zonaprop.com.ar/es/articles/3513304-terminos-y-condiciones-de-uso',
      wording: 'Términos y Condiciones de Uso',
      tag: null
    },
    termsAndConditionsHiring: {
      url: 'https://help.zonaprop.com.ar/s/article/terminos-y-condiciones-generales-de-contratacion',
      wording: 'Términos y Condiciones de Contratación',
      tag: null
    },
    privacyPolicy: {
      url: 'http://help.zonaprop.com.ar/es/articles/3513356-politica-de-privacidad',
      wording: 'Política de privacidad',
      tag: null
    },
    qualityPolicy: {
      url: 'https://help.zonaprop.com.ar/es/articles/3786664-politica-de-gestion-de-calidad',
      wording: 'Política de Gestión de Calidad',
      tag: null
    }
  },
  siteName: {
    name: 'zonaprop.com.ar'
  },
  logo: {
    src: ZonaLandingImgLOGO
  }
};

export { ZPARDataFooter };
